import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminBlogList from "@/pages/AdminBlogList";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/blog/")({
  head: () => seoHead("/admin/blog/"),
  component: () => (
    <StaffAdminGate><AdminBlogList /></StaffAdminGate>
  ),
});
